import { TacticMovie } from "@/types/tacticMovie";
import { client } from "@/api/client";

export async function fetchTacticMovies(url: string): Promise<TacticMovie[]> {
  const { data } = await client.get(url).catch((error) => {
    throw new Error(error.response.message);
  });
  return data;
}
